import { useStaticQuery, graphql } from 'gatsby';

const useSite = () => {
  const { strapiSiteSite } = useStaticQuery(graphql`
    query StrapiSiteSiteQuery {
      strapiSiteSite {
        defaultImage {
          name
          url
          height
          width
          localFile {
            childImageSharp {
              gatsbyImageData(
                layout: CONSTRAINED
                width: 1200
                quality: 90
                placeholder: BLURRED
              )
            }
          }
        }
        fixedDefaultImage: defaultImage {
          url # needed for projection
          src: url
          name
          height
          width
          localFile {
            childImageSharp {
              gatsbyImageData(
                layout: FIXED
                width: 400
                quality: 80
              )
            }
          }
        }
        title
        titleSeparator
        description

        googleMapsApiKey
        recaptchaApiKey

        alert: childStrapiSiteSiteAlert {
          childMarkdownRemark {
            html
          }
        }
      }
    }
  `);

  return strapiSiteSite;
};

export default useSite;
